import { Entity } from '../../types/entity';
import { GroupRowCsv, GroupTemplateCsv } from '../../types/group';

/**
 * Check if group csv file is valid
 *
 * @param rows Data parsed from csv file
 * @returns [{errorMessage}, GroupRow[]]
 */
export function validateData(rows: GroupTemplateCsv[], entities: Entity[]): [{ [rowNumber: string]: string[] }, GroupRowCsv[]] {
    const errorMessages: { [rowNumber: string]: string[] } = {};
    const groupRows: GroupRowCsv[] = [];

    const names: string[] = [];
    const rowEntityIds: string[] = [];

    for (const row of rows) {
        const rowNumber = `${rows.indexOf(row) + 2}`;
        const messages: string[] = [];

        // Skip empty rows
        if (Object.values(row).every((v) => !v)) {
            continue;
        }

        if (row['Name *'].trim() === '') {
            messages.push(`'Name' field cannot be empty.`);
        }

        if (names.includes(row['Name *'].trim().toLowerCase())) {
            messages.push(`Values in 'Name' field must be unique.`);
        } else {
            names.push(row['Name *'].trim().toLowerCase());
        }

        const rowEntities = Object.values(row)
            .slice(2)
            .filter((val) => val !== '')
            .map((entity) => entity.trim());

        // Check if entity exists and entity does not currently belong to a group
        const entityIds = rowEntities?.map((entity) => {
            const matchingEntity = entities?.find((ent) => ent.name.toLowerCase() === entity.toLowerCase());
            if (!matchingEntity) {
                messages.push(`${entity} does not exist or it already belongs to a group.`);
                return '';
            }
            if (rowEntityIds.includes(matchingEntity.id)) {
                messages.push(`${matchingEntity.name} already belongs to a group in a previous row.`);
                return '';
            }
            rowEntityIds.push(matchingEntity.id);
            return matchingEntity.id;
        });

        if (messages.length !== 0) {
            errorMessages[rowNumber] = messages;
        } else {
            const groupRow = {
                name: row['Name *'].trim(),
                description: row.Description.trim() === '' ? undefined : row.Description.trim(),
                entities: entityIds as string[],
            };
            groupRows.push(groupRow);
        }
    }

    return [errorMessages, groupRows];
}
